"use client";

import urls from '@/utils/urls/urls';
import React from 'react'
import "swiper/css";
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function CorporateLogo({ corporateLogo }: { corporateLogo: any }) {
    return (
        <>
            <Swiper className="partner-slider owl-carousel owl-theme d-flex gap-4 justify-content-between"
                style={{
                    display: "flex !important",
                }}
                slidesPerView={6}
                spaceBetween={30}
                modules={[Autoplay, Navigation]}
                navigation={{
                    prevEl: ".destination-card2-prev",
                    nextEl: ".destination-card2-next",
                }}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                speed={1000}
                loop={true}
            // breakpoints={{
            //     320: { slidesPerView: 1, spaceBetween: 10 },
            //     640: { slidesPerView: 2, spaceBetween: 20 },
            //     1024: { slidesPerView: 3, spaceBetween: 30 }
            // }}
            >
                {corporateLogo?.map((logo: any) => (
                    <SwiperSlide key={logo?.id}>
                        <img src={`${urls?.image}${logo.image}`} alt="thumb" className="corporate-logo" />
                    </SwiperSlide>
                ))}
                {/* <SwiperSlide><img src="../assets/img/partner/AMC Knit Composite Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Anowara Knit Composite Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Aswad Composite Mills Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Fakir Fashions Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Fareast Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/FourHDyeingPrintingLtd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Giant Textiles Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Grammen Fabrics Ltd Eurotex Knitwear Ltd.jpg" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/HAMS Garments Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Interstoff Apparels Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/JM Fabrics Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Metro Knitting Dyeing industries Ltd.jpg" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Mondol Knitwears Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/NR knitting.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Pakiza Knitting Dyeing Industries Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Rahman Knit Composite Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/S M Knitwears Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide>
                <SwiperSlide><img src="../assets/img/partner/Square Fashions Ltd.png" alt="thumb" className="corporate-logo" /></SwiperSlide> */}
                {/* <img src="../assets/img/partner/03.png" alt="thumb" className="" /> */}
            </Swiper>

        </>
    )
}
